module.exports = __webpack_public_path__ + "static/media/mstile-150x150.1489ba7d.png";